import z from 'zod';
import { nameFieldSchema } from '@welbe/design-system';

const DEFAULT_MESSAGE = '* Este campo es obligatorio';
const TITLE_MESSAGE = '* Selecciona el título del personal médico';

const requiredFieldConfig = {
	required_error: DEFAULT_MESSAGE,
	invalid_type_error: DEFAULT_MESSAGE,
};

export const doctorDrawerSchema = (hasSires: boolean) =>
	z
		.object({
			id: z.string().nullish(),
			firstName: nameFieldSchema,
			middleName: nameFieldSchema.nullish(),
			lastName: nameFieldSchema.nullish(),
			hasNoMiddleName: z.boolean().optional(),
			hasNoLastName: z.boolean().optional(),
			nationalIdentity: z.string({ required_error: DEFAULT_MESSAGE }),
			birthDate: z.string(requiredFieldConfig),
			countryCode: z.number(requiredFieldConfig),
			contactNumber: z.string({ required_error: DEFAULT_MESSAGE }),
			federalEntityCode: z.number(requiredFieldConfig),
			email: z.string(requiredFieldConfig).email(),
			branchOfficeIds: z
				.string(requiredFieldConfig)
				.array()
				.min(1, DEFAULT_MESSAGE),
			specialtyIds: !hasSires
				? z.string(requiredFieldConfig).array().min(1, DEFAULT_MESSAGE)
				: z.string().array().nullish(),
			doctorPersonalTypeId: z.string(requiredFieldConfig),
			title: z.string({
				required_error: TITLE_MESSAGE,
				invalid_type_error: TITLE_MESSAGE,
			}),
			sex: z.string(requiredFieldConfig),
			professionalLicenseId: z.string(requiredFieldConfig),
			university: z.string().nullish(),
			nationalityCode: z.number(requiredFieldConfig),
			countryResidenceCode: hasSires
				? z.number(requiredFieldConfig)
				: z.number().nullish(),
			federalEntityResidenceCode: hasSires
				? z.number(requiredFieldConfig)
				: z.number().nullish(),
			municipalityResidenceCode: hasSires
				? z.number(requiredFieldConfig)
				: z.number().nullish(),
			localityResidenceCode: hasSires
				? z.number(requiredFieldConfig)
				: z.number().nullish(),
		})
		.superRefine((data, ctx) => {
			if (data.birthDate) {
				const today = new Date();
				const birth = new Date(data.birthDate);
				const age =
					today.getFullYear() -
					birth.getFullYear() -
					(today <
					new Date(today.getFullYear(), birth.getMonth(), birth.getDate())
						? 1
						: 0);

				if (age < 18) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: '* El profesional médico debe tener al menos 18 años',
						path: ['birthDate'],
					});
				} else if (age > 90) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: '* El profesional médico no puede tener más de 90 años',
						path: ['birthDate'],
					});
				}
			}
		});
